import React from "react";
import { Filters } from "../../../../../../../modules/Common/components/Filters";
import { useForm } from "antd/lib/form/Form";
import { Col, Form, Row } from "antd";
import { DatePicker } from "../../../../../../../modules/Common/components/DatePicker";
import { ProgramsSelect } from "../../../../../../../common/components";
import DateRangePicker from "../../../../../../../common/components/DateRangePicker/DateRangePicker";
import { setFormInputValue } from "../../../../../../../common/helpers";
import { datePickerDividerValidation } from "../../../../../../../common/helpers/datePickerDividerValidation";
import { ADDITIONAL_CURRENCY_SYMBOL_DATE } from "../../../../../../../system/config";

const ReportFilters = ({ setFilters, initialValues, excelButton }) => {
  const [form] = useForm();
  return (
    <Filters
      form={form}
      onApply={setFilters}
      initialValues={initialValues}
      mainFilters={
        <Row gutter={[10, 10]}>
          <Col xs={24} md={12} xl={6}>
            <Form.Item name="date">
              <DateRangePicker
                onChange={(dates) => {
                  setFormInputValue(
                    "date",
                    {
                      from: dates[0],
                      to: dates[1],
                    },
                    form
                  );
                }}
                disabledDate={(current, dateRangeValue) =>
                  datePickerDividerValidation(
                    current,
                    dateRangeValue,
                    ADDITIONAL_CURRENCY_SYMBOL_DATE
                  )
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={6}>
            <ProgramsSelect />
          </Col>
          <Col xs={24} md={4} xl={2}>
            {excelButton}
          </Col>
        </Row>
      }
    />
  );
};

export default ReportFilters;
